import { render, staticRenderFns } from "./actionsCellRenderer.vue?vue&type=template&id=8c524224&scoped=true"
import script from "./actionsCellRenderer.ts?vue&type=script&lang=ts&external"
export * from "./actionsCellRenderer.ts?vue&type=script&lang=ts&external"
import style0 from "./actionsCellRenderer.vue?vue&type=style&index=0&id=8c524224&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c524224",
  null
  
)

export default component.exports